import "./LoginExpirado.css";
import alertWarning from "../../assets/svgs/alert-warning.svg";
import { useEffect } from "react";

const LoginExpirado = () => {
  const reload = () => {
    const lastPath = localStorage.getItem("lastPathBeforeSessionExpired");
    localStorage.removeItem("lastPathBeforeSessionExpired");

    if (
      !lastPath ||
      !lastPath.startsWith("/") ||
      lastPath.startsWith("//") ||
      lastPath.includes("\\")
    ) {
      globalThis.location.href = "/";
      return;
    }

    try {
      const destination = new URL(lastPath, globalThis.location.origin);
      globalThis.location.href =
        destination.origin === globalThis.location.origin
          ? `${destination.pathname}${destination.search}${destination.hash}`
          : "/";
    } catch {
      globalThis.location.href = "/";
    }
  };

  useEffect(() => {
    localStorage.removeItem("materialPartDesc");
    localStorage.removeItem("materialPartNumber");
    localStorage.removeItem("selectValue");
    localStorage.removeItem("startDate");
    localStorage.removeItem("endDate");
    localStorage.removeItem("classificationQuizStartDate");
    localStorage.removeItem("classificationQuizFinishDate");
    localStorage.removeItem("classificationApprovalStartDate");
    localStorage.removeItem("classificationApprovalEndDate");
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      reload();
    }, 2000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="login-container">
      <div className="container-exp">
        <div>
          <img
            className="img-alert"
            src={alertWarning}
            alt="imagem de alerta"
          />
        </div>
        <span className="text-exp">Sessão Expirada</span>

        <div className="line"></div>
        <div className="text-apli">
          <p style={{ height: "10px" }}>
            Sua sessão expirou por segurança. Em instantes, você será
          </p>
          <p>redirecionado para continuar usando a aplicação normalmente.</p>
        </div>
      </div>
    </div>
  );
};

export default LoginExpirado;
